export default __webpack_public_path__ + "c7c907811ff878e29a5adc7816c00f84.svg";